import { AppThunk } from "../../store";
import { paymentActions } from "./paymentSlice";
import { apiFetch } from "../../../utils/api";
import { PaymentInitializeResponse } from "../../../types/paymentTypes";

export const fetchPaymentsForBooking =
  (bookingId: number): AppThunk =>
  async (dispatch) => {
    try {
      dispatch(paymentActions.startLoading());
      const data = await apiFetch(`/api/payments/bookings/${bookingId}`, {}, true);
      dispatch(paymentActions.setPaymentsForBooking({ bookingId, payments: data }));
    } catch (e: any) {
      dispatch(paymentActions.setError(e.message));
    } finally {
      dispatch(paymentActions.endLoading());
    }
  };

export const initializePayment =
  (bookingId: number, email: string): AppThunk<PaymentInitializeResponse | null> =>
  async (dispatch) => {
    try {
      dispatch(paymentActions.startLoading());
      const data: PaymentInitializeResponse = await apiFetch(
        `/api/payments/bookings/${bookingId}/initialize`,
        { method: "POST", body: JSON.stringify({ email }) },
        true
      );
      await dispatch(fetchPaymentsForBooking(bookingId));
      return data;
    } catch (e: any) {
      dispatch(paymentActions.setError(e.message));
      return null;
    } finally {
      dispatch(paymentActions.endLoading());
    }
  };

export const verifyPayment =
  (reference: string, bookingId: number): AppThunk =>
  async (dispatch) => {
    try {
      dispatch(paymentActions.startLoading());
      await apiFetch(`/api/payments/verify/${reference}`, { method: "POST" }, true);
      await dispatch(fetchPaymentsForBooking(bookingId));
    } catch (e: any) {
      dispatch(paymentActions.setError(e.message));
    } finally {
      dispatch(paymentActions.endLoading());
    }
  };
